"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    form: {
      type: Object,
      default: function _default() {}
    },
    rules: {
      type: Object,
      default: function _default() {}
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: ''
    },
    lookupList: {
      type: Object,
      default: function _default() {}
    },
    isBailianFlag: {
      type: Boolean,
      default: false
    },
    hasErrorTable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      listLoading: false,
      pageName: 'OtherSales'
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  methods: {
    updateFormValue: function updateFormValue(v, key, row) {
      row[key] = v;
      if (this.isBailianFlag) {
        this.$emit('valid-table', v);
      }
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    getSummaries: function getSummaries(param) {
      var _this = this;
      var columns = param.columns,
        data = param.data;
      var sums = []; // 声明变量
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this.$t('salesStatus.column.salesTotal');
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (column.property === 'stock' ||
        // 需要显示和合计纵列
        column.property === 'monthlyAvgSales') {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += '';
        }
      });
      return sums;
    }
  }
};